module.exports = __webpack_public_path__ + "img/suzhouMuseum.306f419f.png";